import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Layout from "@/components/app/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [token, setToken] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => { setToken(params.get("token") || ""); }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password-reset/confirm", { token, new_password: pw });
      toast.success("Password updated. Please log in.");
      nav("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed. Request a new link.");
    } finally { setLoading(false); }
  };

  return (
    <Layout>
      <section className="max-w-md mx-auto px-4 py-20">
        <h1 className="font-display text-3xl font-bold mb-2">Set a new password</h1>
        <p className="text-sm text-muted-foreground mb-6">Enter a new password for your CREATIVE HUB account.</p>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Reset token</Label><Input value={token} onChange={(e) => setToken(e.target.value)} required data-testid="reset-page-token" /></div>
          <div><Label>New password</Label><Input type="password" minLength={6} required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-page-pw" /></div>
          <Button type="submit" disabled={loading} className="w-full bg-[hsl(var(--accent))] hover:bg-[hsl(15_100%_55%)] text-white" data-testid="reset-page-submit">
            {loading ? "Updating…" : "Update password"}
          </Button>
        </form>
      </section>
    </Layout>
  );
}
